import { trpc } from "#/lib/trpc/client"
import { useQuery } from "@tanstack/react-query"

// Shared so the upload mutation can update this cached status on success (see useUploadIdDocuments).
export const photoIdOnFileQueryKey = ["telemedicine", "getPhotoIdOnFile"]

export function usePhotoIdOnFile(enabled: boolean) {
  return useQuery({
    queryKey: photoIdOnFileQueryKey,
    queryFn: () => trpc.telemedicine.getPhotoIdOnFile.query(),
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity
  })
}
